// src/components/Header.js
import React from "react";
import { AppBar, Button, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Header = () => (
  <AppBar position="static">
    <Toolbar>
      <Typography variant="h6" component="div" sx={{ flexGrow: 1, paddingLeft: "20px" }}>
        Admin Dashboard
      </Typography>
      <Button variant="contained" color="primary">
        <Link to='updateprofile' style={{color:'white',textDecoration:'none'}}>
        Change Password
        </Link>
      </Button>
    </Toolbar>
  </AppBar>
);

export default Header;
